import styled from "styled-components"

export const Icon = styled.img`
  width:24px;
  height:24px;

`
export const Page16Container = styled.div`
    display: flex;
    background-color: black;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    filter: brightness(${props => props.degree});

  @media screen and (max-width: 400px){
    height: 100%;
  }


`
export const Page16Wrapper = styled.div`
    margin: 0px 100px;



  @media screen and (max-width: 950px){
    margin:0px 20px;
  }
`
export const Page16Content = styled.section`
    color: white;
    margin-top: 10px ;
    text-align: center; 
    display: flex;
    flex-direction: column;
    height: inherit;
`
export const Page16Head = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
  width:100%;
`
export const Page16HeadCaption = styled.div`
    color: white;
    font-size: 32px;
    font-weight: bold;
`
export const Page16CardContainer = styled.div`
    display:grid;
    grid-template-columns: 16.1% 16.1% 16.1% 16.1% 16.1% 16.1% ;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    margin-top: 30px;
    padding: 0px 100px;
    background-size:cover;
    background-color:black;

    @media screen and (max-width: 950px){
    padding: 0px 20px;
    grid-template-columns:  auto auto auto  ;
  }
  
  @media screen and (max-width: 500px){
    padding: 0px 20px;
    display: flex;
    flex-direction:column;
    margin-bottom: 20px;
  }
  


`

export const Page16Card = styled.div`
    display: flex;
    flex: 1;
    flex-direction:column;
    background-color:#262626;
    border-radius: 10px;
`
export const Page16CardWrapper = styled.div`
    margin: 20px;
    display: flex;
    flex-direction: column;
    align-items:center;

`
export const Page16CardImage = styled.img`
    width: 100%;
    height: 100%;
    
`
export const Page16CardContent = styled.div`
    
`
export const Page16CardCaption1 = styled.div`
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
    
    @media screen and (max-width:1300px){
      font-size:14px;
      line-height: 16px;
    }
`
export const Page16CardCaption2 = styled.div`
    color: #8c8c8c
    font-size:12px;
    line-height: 15px;
    margin-top: 7px;

    @media screen and (max-width:1300px){
      font-size:10px;
      line-height: 13px;
    }
    
`
export const Page16CardText1 = styled.span`
    
`
export const Page16CardText2 = styled.span`
    
`

export const Page16ButtonWrapper = styled.div`
    display:grid;
    grid-template-columns: 20% 80%;
    grid-column-gap:10px;
    margin-top:15px;
`
export const Page16InfoButton = styled.button`
    background-color:black;
    padding: 10px 5px;
    color: white;
    border-radius: 10px;
    border: none;
`
export const Page16RentButton = styled.button`
    padding: 10px 5px;
    background-color:black;
    color: white;
    border-radius: 10px;
    border: none;

    
`
export const LinkIcon = styled.a`
  
`